import { toast } from 'react-toastify';

const showNotification = (message, type) => {
    switch (type) {
        case 'success':
            toast.success(message, { position: toast.POSITION.TOP_RIGHT, closeOnClick: false, rtl: false, pauseOnFocusLoss: false, draggable: false, pauseOnHover: false, hideProgressBar: true });
            break;
        case 'warning':
            toast.warning(message, { position: toast.POSITION.TOP_RIGHT, closeOnClick: false, rtl: false, pauseOnFocusLoss: false, draggable: false, pauseOnHover: false, hideProgressBar: true });
            break;
        case 'error':
            toast.error(message, { position: toast.POSITION.TOP_RIGHT, closeOnClick: false, rtl: false, pauseOnFocusLoss: false, draggable: false, pauseOnHover: false, hideProgressBar: true });
            break;
        default:
            break;
    }
};

export default showNotification;
